import numeral from 'numeral'

export const sortData = (data, caseType) => {
    const sortedData = [...data]
    return sortedData.sort((a, b) => a[caseType] > b[caseType] ? -1 : 1);

}

export const prettyPrintStat = (stat) =>  stat? `+${numeral(stat).format("0.0a")}` : "+0"
